
/**
Author - Babajan khan
Github - https://www.github.com/babajanpatan/
**/

import Header from "./Header.container";

export default Header;
